import { Overlay, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';

import {
  NOTIFICATION_BAR_DATA,
  NotificationBarData,
} from './notification-bar-data.model';
import { NotificationBarRef } from './notification-bar-ref';
import { NotificationBarComponent } from './notification-bar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationBarService {
  private ref!: NotificationBarRef;

  constructor(
    private overlay: Overlay,
    private positionBuilder: OverlayPositionBuilder
  ) {}

  open(data: NotificationBarData) {
    if (this.ref) {
      this.ref.close(false);
    }

    const overlayRef = this.overlay.create({
      width: '100%',
      positionStrategy: this.positionBuilder.global().bottom(),
    });

    this.ref = new NotificationBarRef(overlayRef);

    const inj = Injector.create({
      providers: [
        {
          provide: NOTIFICATION_BAR_DATA,
          useValue: data,
        },
        {
          provide: NotificationBarRef,
          useValue: this.ref,
        },
      ],
    });

    const portal = new ComponentPortal(NotificationBarComponent, null, inj);
    overlayRef.attach(portal);
    return this.ref;
  }

  closeAll() {
    this.ref && this.ref.close();
  }
}
